import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';

const NAV = [
  { to: '/admin/dashboard', label: 'Dashboard' },
  { to: '/admin/ventas', label: 'Ventas' },
  { to: '/admin/comprobantes', label: 'Comprobantes' },
  { to: '/admin/productos', label: 'Productos' },
  { to: '/admin/inventario', label: 'Inventario' },
  { to: '/admin/compras', label: 'Compras' },
  { to: '/admin/clientes', label: 'Clientes' },
  { to: '/admin/proveedores', label: 'Proveedores' },
  { to: '/admin/caja', label: 'Caja' },
  { to: '/admin/cotizaciones', label: 'Cotizaciones' },
  { to: '/admin/guias', label: 'Guías' },
  { to: '/admin/usuarios', label: 'Usuarios' },
  { to: '/admin/reportes', label: 'Reportes' },
  { to: '/admin/configuracion', label: 'Configuración' },
  { to: '/admin/mi-plan', label: 'Mi plan' },
];

const SUPERADMIN_NAV = [{ to: '/admin/superadmin/planes', label: 'Superadmin · Planes' }];

export default function AdminLayout() {
  const { company, ruc, user, theme, logout, businessType, firebaseUser } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isSuperadmin, setIsSuperadmin] = useState(false);

  useEffect(() => {
    let cancelled = false;
    // Acepta superAdmin / superadmin (Firestore)
    const rol = String(user?.rol || '').toLowerCase();
    if (rol === 'superadmin') {
      setIsSuperadmin(true);
      return;
    }
    (async () => {
      if (!firebaseUser) {
        setIsSuperadmin(false);
        return;
      }
      try {
        const token = await firebaseUser.getIdTokenResult();
        if (!cancelled) setIsSuperadmin(token?.claims?.superadmin === true || rol === 'superadmin');
      } catch {
        if (!cancelled) setIsSuperadmin(rol === 'superadmin');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [firebaseUser, user]);

  const primary = theme?.colors?.primary || '#7B1FA2';
  const primaryDark = theme?.colors?.primaryDark || '#6A1B9A';
  const background = theme?.colors?.background || '#EDE7F6';

  const onLogout = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  const navItems = isSuperadmin ? [...SUPERADMIN_NAV, ...NAV] : NAV;

  return (
    <div
      className="admin-shell"
      style={{
        '--primary': primary,
        '--primary-dark': primaryDark,
        '--bg-app': background,
      }}
    >
      <header className="topbar">
        <button
          type="button"
          className="hamburger"
          aria-label="Abrir menú"
          onClick={() => setOpen((v) => !v)}
        >
          ☰
        </button>
        <div className="brand">
          <span className="brand-mark">MF</span>
          <div>
            <strong>{theme?.shortLabel || 'MI FACTURADOR'}</strong>
            <div className="brand-sub">
              {company?.nombreComercial || company?.razonSocial || 'Empresa'} · RUC {ruc}
            </div>
          </div>
        </div>
        <div className="topbar-right">
          <span className="vertical-pill">{businessType}</span>
          <button type="button" className="user-chip" onClick={() => setMenuOpen((v) => !v)}>
            {user?.name || user?.email || 'Usuario'} ▾
          </button>
          {menuOpen ? (
            <div className="user-menu">
              <div className="user-menu-meta">
                <div>{user?.name} {user?.apellidos}</div>
                <div className="muted">{user?.email}</div>
                <div className="muted">Rol: {user?.rol || '—'}</div>
              </div>
              <button type="button" onClick={onLogout}>Cerrar sesión</button>
            </div>
          ) : null}
        </div>
      </header>

      <div className="admin-body">
        <aside className={`sidebar ${open ? 'open' : ''}`}>
          <nav>
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) => (isActive ? 'active' : undefined)}
                onClick={() => setOpen(false)}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </aside>
        {open ? <div className="sidebar-backdrop" onClick={() => setOpen(false)} /> : null}
        <main className="content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
